export default "__VITE_ASSET__CLRSgQgQ__"